<template lang="pug">
  .container-dialog(id="SetPlayListItemZoneProperties-container")
    el-form.zone-form(v-on:submit.native.prevent="saveVisualRestriction()",
        :model="restrictionData",
        ref="restrictionDataForm",
        label-width="120px",
        id="SetPlayListItemZoneProperties-restrictionDataForm"
      )
      .column
        h4
          span {{$t('Position:')}} &nbsp;
        el-form-item(:label="$t('Align')")
          el-dropdown(id="SetPlayListItemZoneProperties-anchorModeDropDown", trigger="click", @command="selectAnchorMode")
            el-button(
              size="mini",
              type="success",
            )
              span {{$t('mode')}} &nbsp;
              font-awesome-icon(icon="caret-down")
            el-dropdown-menu(slot='dropdown')
              el-dropdown-item(id="SetPlayListItemZoneProperties-anchorTopLeftButton", command="top-left")
                .anchor-button-screen
                  .anchor-button-zone.top-left
              el-dropdown-item(id="SetPlayListItemZoneProperties-anchorTopRightButton", command='top-right')
                .anchor-button-screen
                  .anchor-button-zone.top-right
              el-dropdown-item(id="SetPlayListItemZoneProperties-anchorBottomLeftButton", command='bottom-left')
                .anchor-button-screen
                  .anchor-button-zone.bottom-left
              el-dropdown-item(id="SetPlayListItemZoneProperties-anchorBottomRightButton", command='bottom-right')
                .anchor-button-screen
                  .anchor-button-zone.bottom-right
              el-dropdown-item(id="SetPlayListItemZoneProperties-anchorTopMiddleButton", command='top-middle')
                .anchor-button-screen
                  .anchor-button-zone.top-middle
              el-dropdown-item(id="SetPlayListItemZoneProperties-anchorMiddleRightButton", command='middle-right')
                .anchor-button-screen
                  .anchor-button-zone.middle-right
              el-dropdown-item(id="SetPlayListItemZoneProperties-anchorBottomMiddleButton", command='bottom-middle')
                .anchor-button-screen
                  .anchor-button-zone.bottom-middle
              el-dropdown-item(id="SetPlayListItemZoneProperties-anchorMiddleLeftButton", command='middle-left')
                .anchor-button-screen
                  .anchor-button-zone.middle-left
              el-dropdown-item(id="SetPlayListItemZoneProperties-anchorMiddleMiddleButton", command='middle-middle')
                .anchor-button-screen
                    .anchor-button-zone.middle-middle
        el-form-item(:label="$t('X')", prop="anchorX")
          el-input(id="SetPlayListItemZoneProperties-anchorXInput", v-model="restrictionData.anchorX", type="number", placeholder="X", ref="anchorX", @blur='validateInt("anchorX")')
        el-form-item(:label="$t('Y')", prop="anchorY")
          el-input(id="SetPlayListItemZoneProperties-anchorYInput", v-model="restrictionData.anchorY", type="number", placeholder="Y", ref="anchorY", @blur='validateInt("anchorY")')
      .column
        h4
          span {{$t('Dimensions:')}}
        el-form-item(:label="$t('Reset to')")
          el-button-group(size="mini")
            el-button(id="SetPlayListItemZoneProperties-resetToLayoutButton", size="mini", type="success", @click='restrictionData.width = playList.playListLayoutWidth; restrictionData.height = playList.playListLayoutHeight')
              span {{ $t('layout') }}
            el-button(id="SetPlayListItemZoneProperties-resetToMediumButton", size="mini", type="success", @click='restrictionData.width = playListItem.File.originalWidthPixels; restrictionData.height = playListItem.File.originalHeightPixels')
              span {{ $t('medium') }}
          span &nbsp; {{$t('dimensions')}}
        el-form-item(:label="$t('Width')", prop="width")
          el-input(id="SetPlayListItemZoneProperties-dimWidthInput", v-model="restrictionData.width", type="number", :placeholder="$t('width px')", ref="width", @blur='validateInt("width")')
        el-form-item(:label="$t('Height')", prop="height")
          el-input(id="SetPlayListItemZoneProperties-dimHeightInput", v-model="restrictionData.height", type="number", :placeholder="$t('height px')", ref="height", @blur='validateInt("height")')
        el-button.float-right(
          id="SetPlayListItemZoneProperties-submitButton",
          type="success",
          size="mini",
          :disabled="isSaving"
          @click="saveVisualRestriction()",
        )
          span {{$t(buttonSaveText())}}
      .errors(v-if="errors.length > 0")
        .error(v-for="error in errors")
          p {{ error }}
</template>

<script>
import Vue from 'vue'
export default {
  props: ['playListItem', 'playList'],
  mounted () {
  },
  data () {
    return {
      errors: [],
      restrictionData: {
        anchorX: this.playListItem.anchorX,
        anchorY: this.playListItem.anchorY,
        width: this.playListItem.width === 0 ? this.playList.playListLayoutWidth : this.playListItem.width,
        height: this.playListItem.height === 0 ? this.playList.playListLayoutHeight : this.playListItem.height
      },
      isSaving: false,
      selectedAnchorMode: undefined
    }
  },
  watch: {
    selectedAnchorMode (oldVal, newVal) {
      const freeSpaceHorizontal = this.playList.playListLayoutWidth - this.restrictionData.width
      const freeSpaceVertical = this.playList.playListLayoutHeight - this.restrictionData.height
      const desiredCoordinates = this.selectedAnchorMode.split('-')
      if (desiredCoordinates[0] === 'middle') {
        this.restrictionData.anchorY = freeSpaceVertical / 2
      } else if (desiredCoordinates[0] === 'bottom') {
        this.restrictionData.anchorY = freeSpaceVertical
      } else if (desiredCoordinates[0] === 'top') {
        this.restrictionData.anchorY = 0
      }
      if (desiredCoordinates[1] === 'middle') {
        this.restrictionData.anchorX = freeSpaceHorizontal / 2
      } else if (desiredCoordinates[1] === 'right') {
        this.restrictionData.anchorX = freeSpaceHorizontal
      } else if (desiredCoordinates[1] === 'left') {
        this.restrictionData.anchorX = 0
      }
    }
  },
  methods: {
    validateInt (key) {
      console.log(isNaN(parseInt(this.restrictionData[key])))
    },
    selectAnchorMode (value) {
      this.selectedAnchorMode = value
    },
    buttonSaveText () {
      if (this.isSaving) return 'saving data...'
      return 'Set visual restriction'
    },
    __validateInput () {
      this.errors = []
      Object.keys(this.restrictionData).forEach((key) => {
        if (isNaN(parseInt(this.restrictionData[key]))) this.errors.push(this.$t('Incorrect value for ') + key)
      })
      return !(this.errors.length > 0)
    },
    async saveVisualRestriction () {
      if (!this.__validateInput()) return
      this.isSaving = true
      const path = `PlayListItem/${this.playListItem.id}`
      await Vue.axios.patch(path, this.restrictionData)
      this.isSaving = false
      this.$emit('close')
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.zone-form {
  display: flex;
}
.anchor-button-screen {
  padding: 0px;
  margin: 10px 0px 0px 0px;
  height: 30px;
  width: 50px;
  border: 1px solid $--color-primary;
  position: relative;
  float: left;
  // transform: scale(0.99);
  .anchor-button-zone {
    position: relative;
    border: 1px solid $--color-success;
    width: 15px;
    height: 15px;
  }
  .top-left {
    left: -1px;
    top: -1px;
  }
  .top-right {
    top: -1px;
    left: 34px;
  }
  .bottom-left {
    top: 14px;
    left: -1px;
  }
  .bottom-right {
    top: 14px;
    left: 34px;
  }
  .top-middle {
    left: 16px;
    top: -1px;
  }
  .middle-right {
    top: 7px;
    left: 34px;
  }
  .bottom-middle {
    top: 14px;
    left: 16px;
  }
  .middle-left {
    top: 7px;
    left: -1px;
  }
  .middle-middle {
    top: 7px;
    left: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/SetPlayListItemZoneProperties.vue